/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import useTranslation from 'Hooks/useTranslation';
import DropzoneAreaIndicator from 'Pages/EditCourseLessons/Components/DropzoneAreaIndicator';
import DropzoneAreaLoadingIndicator from 'Pages/EditCourseLessons/Components/DropzoneAreaLoadingIndicator';
import {
  DropzoneContainer,
  DropzoneArea,
  DropzoneText,
  DropzoneSubContainer,
  VideoContainer,
  videoStyle,
  spanStyle,
  boxStyle,
} from './style';

const selectContent = ({
  urlVideo,
  getInputProps,
  getRootProps,
  progress,
  loading,
  uploadFiles,
  acceptedFileItems,
  fileRejectionItems,
}) => {
  // Traducción
  const { t2 } = useTranslation('EditCourse');

  if (urlVideo === null)
    return (
      <>
        <DropzoneContainer>
          <DropzoneSubContainer>
            <DropzoneAreaIndicator
              progress={progress}
              visible={progress}
              getInputProps={getInputProps}
              getRootProps={getRootProps}
              uploadFiles={uploadFiles}
              acceptedFileItems={acceptedFileItems}
              fileRejectionItems={fileRejectionItems}
            />
            <DropzoneAreaLoadingIndicator
              descriptions={{
                loadingDescription: t2('UploadVideo'),
                dragAndDropDescription: t2('DragAndDropVideo'),
                typeErrorDescription: t2('TypeErrorVideo'),
              }}
              loading={loading}
              getInputProps={getInputProps}
              getRootProps={getRootProps}
              uploadFiles={uploadFiles}
              acceptedFileItems={acceptedFileItems}
              fileRejectionItems={fileRejectionItems}
            />
          </DropzoneSubContainer>
        </DropzoneContainer>
        <p>{t2('TypeExtensionsVideos')}</p>
      </>
    );

  return (
    <VideoContainer>
      <video controls src={urlVideo} style={videoStyle} />
    </VideoContainer>
  );
};

export default selectContent;
